import React from 'react'

export const AddSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.9938 6.09148C10.9938 5.53919 11.4478 5.09148 12.0001 5.09148C12.5523 5.09148 13.0063 5.53919 13.0063 6.09148L13.0063 11.7098L18.6246 11.7098C19.1768 11.7098 19.6246 12.1637 19.6246 12.716C19.6246 13.2683 19.1768 13.7222 18.6246 13.7222L13.0063 13.7222L13.0063 19.3404C13.0063 19.8927 12.5524 20.3404 12.0001 20.3404C11.4478 20.3404 10.9939 19.8927 10.9939 19.3404L10.9938 13.7222L5.37561 13.7222C4.82332 13.7222 4.37561 13.2682 4.37561 12.716C4.37561 12.1637 4.82332 11.7097 5.37561 11.7097L10.9938 11.7097L10.9938 6.09148Z"
        fill="black"
      />
    </svg>
  )
}
